/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A standard Pomodoro is 25 minutes of focused work followed by a 5-minute break. Every fourth break is longer, around 15–30 minutes.`)
};

const es_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Pomodoro estándar son 25 minutos de trabajo enfocado seguidos de un descanso de 5 minutos. Cada cuarto descanso es más largo, entre 15 y 30 minutos.`)
};

const de_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Standard-Pomodoro besteht aus 25 Minuten fokussierter Arbeit, gefolgt von einer 5-minütigen Pause. Jede vierte Pause ist länger, etwa 15–30 Minuten.`)
};

const nl_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een standaard Pomodoro is 25 minuten geconcentreerd werk gevolgd door een pauze van 5 minuten. Elke vierde pauze is langer, ongeveer 15-30 minuten.`)
};

const fr_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Pomodoro standard est composé de 25 minutes de travail concentré suivies d’une pause de 5 minutes. Une pause sur quatre est plus longue, environ 15 à 30 minutes.`)
};

const it_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Pomodoro standard è composto da 25 minuti di lavoro concentrato seguiti da una pausa di 5 minuti. Ogni quarta pausa è più lunga, circa 15–30 minuti.`)
};

const pt_br2_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um Pomodoro padrão é composto por 25 minutos de trabalho focado seguidos de uma pausa de 5 minutos. A cada quatro pausas, uma é mais longa, em torno de 15 a 30 minutos.`)
};

const pt_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um Pomodoro padrão consiste em 25 minutos de trabalho focado seguidos de uma pausa de 5 minutos. A cada quarta pausa é mais longa, cerca de 15 a 30 minutos.`)
};

const ja_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準的なポモドーロは25分の集中作業と5分の休憩で構成されます。4回に1回の休憩は長めで、約15〜30分になります。`)
};

const zh_timer_pomodoro_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准番茄钟是25分钟专注工作，之后休息5分钟。每完成4个番茄钟后会有一次更长的休息，约15–30分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq1_a", locale)
	if (locale === "en") return en_timer_pomodoro_faq1_a(inputs)
	if (locale === "es") return es_timer_pomodoro_faq1_a(inputs)
	if (locale === "de") return de_timer_pomodoro_faq1_a(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq1_a(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq1_a(inputs)
	if (locale === "it") return it_timer_pomodoro_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq1_a(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq1_a(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq1_a(inputs)
	return zh_timer_pomodoro_faq1_a(inputs)
};